import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { OPD_CONST } from "../../../properties/opd-static-properties";
import { Subscription } from "rxjs";
import { GeneralUrlService } from "../../../services/SgeneralUrl.service";
import { OPD_API_URL } from "../../../properties/opd-url-properties";
import { PatientRegistrationService } from "../../../services/Spatient-registration.service";
import { MatTableDataSource } from "@angular/material/table";
import { DialogAddAppointmentPatient } from "../patient-appointment.component";
import { ReplaySubject ,Subject} from "rxjs";

export interface PatientDialogData {
  appointmentType: string;
  doctor: string;
  department: string;
  doctorList: any;
  appointmentDate: string;
  aptmentTypeDesc: string;
  consultationtype: string;
  consultationtypeList: any;
  departmentList: any;
  appointmentTypeList: any;
}
@Component({
  selector: "app-appointment-quick-search",
  templateUrl: "./appointment-quick-search.component.html",
  styleUrls: ["./appointment-quick-search.component.scss"],
})
export class AppointmentQuickSearchComponent implements OnInit, OnDestroy {
  public weekDaysList: any = [];
  appointmentType: string;
  doctorCode: any;
  departmentCode: String;
  private subscriptionList = new Subscription();
  displayedColumns: any = OPD_CONST.appointmentSearchList;
  dataSource = new MatTableDataSource<any>();
  start: number = 0;
  limit: number = 5;
  end: number = this.limit + this.start;
  searchList: any = [];
  noSlots: boolean = false;
  minDate: Object = new Date();
  protected _onDestroy = new Subject<void>();
  
  formQuicKsearch: FormGroup ;

  public doctorFltrCtrl: FormControl = new FormControl();
  public doctorFilteredList: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  doctorList:any;
  appointmentList: any[]=[];
  departmentList: any;

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AppointmentQuickSearchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PatientDialogData,
    public generalApiService: GeneralUrlService,
    private patientRegService: PatientRegistrationService
  ) {}

  ngOnDestroy(): void {
    this.subscriptionList.unsubscribe();
  }

  ngOnInit(): void {
    this.formQuicKsearch = this.formBuilder.group({
      fromDateRange: [""],
      toDateRange: [""],
      fromTimeRange: [""],
      fromToRange: [""],
      doctor: [""],
    });
    this.appointmentType = this.data.appointmentType;
    this.departmentCode = this.data.department;
    this.doctorList = this.data.doctorList;
    this.doctorFilteredList = this.data.doctorList;
    this.appointmentList= this.data.doctorList;
    this.weekDaysList = OPD_CONST.searchweekDays;
    this.weekDaysList.forEach((element) => {
      element.value = false;
    });
    this.doctorFltrCtrl.valueChanges.subscribe((value) => {
      this.doctorFilteredList = this.doctorList.filter((i) =>
        i.desc.toString().toLowerCase().includes(value.toLowerCase())
      );
    })
 
  }

  /**
   * select days
   * @param day
   */
  selecteDays(day) {
    let data = this.weekDaysList.find((item) => item.text == day);
    let indexToUpdate = this.weekDaysList.findIndex((item) => item.text == day);
    this.weekDaysList[indexToUpdate].value = data.value == true ? false : true;
  }
  /**
   * close method
   */
  onNoClick() {
    this.dialogRef.close();
  }

  /**
   * select row and redirect to appointment
   * @param index
   * @param element
   */
  selectRow(index: number, element: any) {
    let starttime = new Date(
      element.availableDate + " " + element.availableStartTime
    );
    let endTime = new Date(
      element.availableDate + " " + element.availableEndTime
    );
    let selectedTime = {
      start: starttime,
      end: endTime,
    };

    let doctorValue = this.formQuicKsearch.controls["doctor"].value
      ? this.formQuicKsearch.controls["doctor"].value
      : "";
    const dialogRef = this.dialog.open(DialogAddAppointmentPatient, {
      width: OPD_CONST.aptref.width,
      data: {
        appointmentDate: OPD_CONST.aptref.selectedDate,
        slotMinutes: OPD_CONST.aptref.slotMints,
        slotId: element.slotId,
        selectedDay: element.availableDate,
        daySlot: [],
        appointmentType: this.appointmentType,
        aptmentTypeDesc: this.data.aptmentTypeDesc,
        doctor: doctorValue,
        department: this.departmentCode,
        consultationtype: this.data.consultationtype,
        consultationtypeList: this.data.consultationtypeList,
        calenderEvent: {},
        doctorList: this.data.doctorList,
        departmentList: this.data.departmentList,
        appointmentTypeList: this.data.appointmentTypeList,
        blocktime: 0,
        reScheduleData: "",
        selectedTime: selectedTime,
        isQuickSearch: true,
      },
    });
    this.dialogRef.close();
  }

  /**
   * search the result
   */
  search() {
    if (this.formQuicKsearch.valid) {
      this.dataSource = new MatTableDataSource<any>();
      let startdate = this.formQuicKsearch.controls["fromDateRange"].value
        ? this.patientRegService.epochDateConvertor(
            this.formQuicKsearch.controls["fromDateRange"].value,
            "start"
          )
        : "";
      let endDate = this.formQuicKsearch.controls["toDateRange"].value
        ? this.patientRegService.epochDateConvertor(
            this.formQuicKsearch.controls["toDateRange"].value,
            ""
          )
        : "";
      let starttime = this.formQuicKsearch.controls["fromTimeRange"].value
        ? this.formQuicKsearch.controls["fromTimeRange"].value + ":00"
        : "";
      let endtime = this.formQuicKsearch.controls["fromToRange"].value
        ? this.formQuicKsearch.controls["fromToRange"].value + ":00"
        : "";
      let selectedDays = [];
      this.weekDaysList.forEach((element) => {
        if (element.value) {
          selectedDays.push(element.text);
        }
      });
      this.doctorCode = this.formQuicKsearch.controls["doctor"].value
        ? this.formQuicKsearch.controls["doctor"].value.code
        : "";
      let url =
        "slot/" +
        this.appointmentType +
        "/Appointment/ListForSuggestedSlot?entities=" +
        this.doctorCode +
        "&departmentCode=" +
        this.departmentCode +
        "&startTime=" +
        startdate +
        "&endTime=" +
        endDate +
        "&fromTime=" +
        starttime +
        "&toTime=" +
        endtime +
        "&days=" +
        selectedDays +
        "";
      this.subscriptionList.add(
        this.generalApiService
          .getTypeApi(OPD_API_URL.OPD_SERVICE, url)
          .subscribe((res: any[]) => {
            if (res != null && res.length > 0) {
              this.noSlots = false;
              this.searchList = res;
              let data = this.getTableData(this.start, this.end);
              this.dataSource = new MatTableDataSource<any>(this.searchList);
            } else this.noSlots = true;
          })
      );
    }
  }
  /**
   * lazy loading on table scroll
   * @param e
   */
  onTableScroll(e) {
    console.log(e);
    const tableViewHeight = e.target.offsetHeight; // viewport
    const tableScrollHeight = e.target.scrollHeight; // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled

    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 200;
    const limit = tableScrollHeight - tableViewHeight - buffer;
    if (scrollLocation > limit) {
      let data = this.getTableData(this.start, this.end);
      const datValue = this.dataSource.data.concat(data);
      this.dataSource = new MatTableDataSource<any>(datValue);
      this.updateIndex();
    }
  }

  /**
   * update the table data
   * @param start
   * @param end
   * @returns
   */
  getTableData(start, end) {
    return this.searchList.filter(
      (value, index) => index >= start && index < end
    );
  }
  /**
   * update index
   */
  updateIndex() {
    this.start = this.end;
    this.end = this.limit + this.start;
  }
  /**
   * clear section
   */
  clear() {
    this.formQuicKsearch.reset();
    this.searchList= [];
    this.dataSource = new MatTableDataSource<any>();
    this.weekDaysList.forEach((element) => {
      element.value = false;
    });
  }
}
